<rask-page
    pageTitle="{{ 'HANDELSSORTIMENT_LIST_SOK' | translate }}"
    [actionShow]="canCreate()"
    [actionFn]="create"
    actionTitle="{{'HANDELSSORTIMENT_DETAIL_SKAPA_NY' | translate}}"
    noPadding>
    <ng-container headerContent>
        <rask-search-panel (handelssortiment)="onhandelssortiment($event)"></rask-search-panel>
        <rask-search-result [handelssortiment]="handelssortiment"></rask-search-result>
    </ng-container>
    <ng-container footerContent>
        <rask-button
            color="secondary"
            popoverClass="pin-popover"
            placement="top-left"
            [autoClose]="'outside'"
            [ngbPopover]="downloadFdiPopup"><span class="fas fa-download"></span> FDI</rask-button>
        <rask-list-selected-items
            [data]="getSelectedListItems()"
            (removeFromSelection)="removeFromSelection($event)"></rask-list-selected-items>
    </ng-container>
</rask-page>

<ng-template #downloadFdiPopup>
    <rask-handelssortiment-file-downloader [getSelectedHs]="getSelectedHs" [getFileName]="getFileName"></rask-handelssortiment-file-downloader>
</ng-template>